import { Component, Inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { OrderShuttleArrivalDeparture } from '../../../../../models/OrderShuttlePlanning.models';
import { AdminService } from '../../../../../services/admin.service';
import { ParkingService } from '../../../../../services/parking.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import moment from 'moment-timezone';

@Component({
  selector: 'app-back-office24-order-shuttle-planning-details',
  templateUrl: './back-office24-order-shuttle-planning-details.component.html',
  styleUrl: './back-office24-order-shuttle-planning-details.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlePlanningDetailsComponent {
  formatTime(dateStr: any): string {
    if (!dateStr) return '';
    return moment.tz(dateStr, 'Europe/Stockholm').format('HH:mm');
  }

  formatDate(dateStr: any): string {
    if (!dateStr) return '';
    return moment.tz(dateStr, 'Europe/Stockholm').format('YYYY-MM-DD');
  }
  // @Input() date;
  displayedColumnsShuttle: string[] = [
    'totalOrders',
    'totalPassengers',
    'totalBaggage',
    'totalChildseats',
    'totalCars',
    'totalFlights'
  ];
  displayedColumnsOrders: string[] = [
    'arrivalDepartureDate',
    'passengers',
    'baggage',
    'childseats',
    'cars',
    'flightNr',
    'terminal',
    'orderNr'
  ];

  carFilter: string = 'all';
  componentDestroyed$: Subject<boolean> = new Subject();

  get totalPassengersWithCars(): number {
    return this.orderShuttleArrivalDeparture.orderShuttlePlanRows
      .filter(row => row.cars > 0)
      .reduce((sum, row) => sum + row.passengers, 0);
  }

  get totalPassengersWithoutCars(): number {
    return this.orderShuttleArrivalDeparture.orderShuttlePlanRows
      .filter(row => row.cars === 0)
      .reduce((sum, row) => sum + row.passengers, 0);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public orderShuttleArrivalDeparture: OrderShuttleArrivalDeparture,
    public snackBar: MatSnackBar,
    public adminService: AdminService,
    public parkingService: ParkingService,
    public datepipe: DatePipe,
    public router: Router
  ) {
  }

  public formatter = Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Stockholm",
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

  ngOnInit(): void { }

  get filteredOrderRows() {
    if (this.carFilter === 'all') {
      return this.orderShuttleArrivalDeparture.orderShuttlePlanRows;
    }
    return this.orderShuttleArrivalDeparture.orderShuttlePlanRows.filter(row => {
      if (this.carFilter === 'with-cars') {
        return row.cars > 0;
      }
      if (this.carFilter === 'without-cars') {
        return row.cars === 0;
      }
      return true;
    });
  }

  goToOrder(orderId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/admin/back-office24-order/${orderId}`]));
    window.open(url, '_blank');
  }



  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}


